import {
  GAME_ID,
  SELECT_LEVEL,
  INIT_CURRICULUM,
} from '../foodTruckConstants';

const initialState = {
  // id of current level, starts from 0
  currentLevelId: null,
};

const foodTruckCurriculumReducer = (state = initialState, action) => {
  if (action.gameId !== GAME_ID) {
    return state;
  }

  switch (action.type) {
    case SELECT_LEVEL: {
      const { levelId } = action.payload;

      return {
        ...state,
        currentLevelId: levelId,
      };
    }
    case INIT_CURRICULUM: {
      return {
        ...initialState,
      };
    }
    default:
      return state;
  }
};

export default foodTruckCurriculumReducer;
